import { Box, Button, Dialog, DialogActions, DialogContent, FormControl, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, useMediaQuery } from '@mui/material';
import React, { memo, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { useTheme } from '@emotion/react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useLocation, useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createVendorPayment, getAllPaymentVendor, getVendorPayment, updateVendorPayment } from '../../../redux/slice/vendorPayment.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Image_URL } from '../../../utils/baseURL';

const AddVendorPayment = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const navigate = useNavigate()
    const { state } = useLocation();
    const purchaseId = state?.purchaseId;
    const AllpurchaseData = useSelector(state => state.vendorPayment.purchaseData)?.find(a => a._id == purchaseId)
    const isMobile = useMediaQuery('(max-width:500px)');

    const AllvendorPayment = useSelector(state => state.vendorPayment.VendorPayment)
    const id = state?._id;

    const validationSchemas =
        Yup.object({});

    const initialValues = {
        VendorpurchaseId: purchaseId,
        StoreAmount: "",
        VendorTotalAmount: "",
        VendorPendingAmount: "",
        VendorPaymentDetails: [{
            VendorPaymentDate: '',
            VendorPaymentAmount: '',
            VendorPaymentTDS: '',
            VendorPaymentTotal: '',
            VendorPaymentRemark: '',
        }],
    };

    useEffect(() => {
        dispatch(getVendorPayment())
        dispatch(getAllPaymentVendor())

    }, [dispatch])

    const [vendorPayment, setvendorPayment] = useState(initialValues.VendorPaymentDetails);
    const [newPaymentIndex, setNewPaymentIndex] = useState(null);
    const [vendorpaymentdata, setvendorpaymentdata] = React.useState()
    const { handleBlur, handleChange, values, touched, errors, resetForm, setFieldValue, setValues, validateForm } = useFormik({
        initialValues,
        validationSchema: validationSchemas,
    });
    const [isEditMode, setIsEditMode] = useState(false);

    const handleAddVendorPayment = () => {
        const newIndex = vendorPayment.length;
        setvendorPayment([...vendorPayment,
        {
            VendorPaymentDate: '',
            VendorPaymentAmount: '',
            VendorPaymentTDS: '',
            VendorPaymentTotal: '',
            VendorPaymentRemark: '',
        }]);
        setNewPaymentIndex(newIndex);
    }

    useEffect(() => {
        if (AllvendorPayment) {
            setvendorpaymentdata(AllvendorPayment.find(v => v._id == id))
        }
    }, [id, AllvendorPayment])

    useEffect(() => {
        if (id && vendorpaymentdata) {
            setValues(vendorpaymentdata);
            setvendorPayment(vendorpaymentdata.VendorPaymentDetails);
            setIsEditMode(true);
        }
    }, [id, dispatch, vendorpaymentdata]);

    // const vendorPaymentDetailsWithTotal = values.VendorPaymentDetails.map(payment => ({
    //     ...payment,
    //     VendorPaymentTotal: Number(payment.VendorPaymentAmount || 0) + Number(payment.VendorPaymentTDS || 0),
    // }));

    const handleSubmit = () => {
        validationSchemas.validate(values, { abortEarly: false })
            .then(() => {
                setFieldValue({
                    ...values,
                    VendorPaymentDetails: values.VendorPaymentDetails.map(payment => ({
                        ...payment,
                        VendorPaymentTotal: Number(payment.VendorPaymentAmount || 0) + Number(payment.VendorPaymentTDS || 0),
                    })),
                });

                const submissionValues = {
                    ...values,
                    VendorpurchaseId: purchaseId,
                    VendorPaymentDetails: values.VendorPaymentDetails.map(payment => ({
                        ...payment,
                        VendorPaymentTotal: Number(payment.VendorPaymentAmount || 0) + Number(payment.VendorPaymentTDS || 0),
                    })),
                    StoreAmount: AllpurchaseData?.storeData?.[0]?.amountTotal,
                    VendorTotalAmount: values.VendorPaymentDetails.reduce((acc, curr) => acc + Number(curr.VendorPaymentAmount || 0) + Number(curr.VendorPaymentTDS || 0), 0),
                    VendorPendingAmount: AllpurchaseData?.storeData?.[0]?.amountTotal - values.VendorPaymentDetails.reduce((acc, curr) => acc + Number(curr.VendorPaymentAmount || 0) + Number(curr.VendorPaymentTDS || 0), 0),
                };


                if (id) {
                    delete submissionValues.isActive;
                    delete submissionValues.createdAt;
                    delete submissionValues.updatedAt;
                    console.log("submissionValues", submissionValues)
                    dispatch(updateVendorPayment({ ...submissionValues, id: submissionValues._id }))
                        .then(() => {
                            Promise.all([
                                dispatch(getVendorPayment()),
                                dispatch(getAllPaymentVendor())
                            ]).then(() => {
                                navigate('/admin/vendor-payment');
                            });
                        });
                } else {
                    dispatch(createVendorPayment(submissionValues)).then(() => {
                        Promise.all([
                            dispatch(getVendorPayment()),
                            dispatch(getAllPaymentVendor())
                        ]).then(() => {
                            navigate('/admin/vendor-payment');
                        });
                    });
                }
                console.log("submissionValues", submissionValues)
                resetForm();
            })
            .catch((validationErrors) => {
                console.log("Form validation errors:", validationErrors);
                alert("Please fill in all required fields before submitting.");
            });
    }

    const [openDialog, setOpenDialog] = useState(false);

    const handlePrint = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
            {id ? (
                <Header
                    title="UPDATE VENDOR PAYMENT"
                    subtitle="Update Your Vendor Payment Here"
                />
            ) : (
                <Header
                    title="ADD VENDOR PAYMENT"
                    subtitle="Manage Your Vendor Payment Here"
                />
            )}
            <Box sx={{
                m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                bgcolor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0',
            }}>
                <TableContainer>
                    <Table style={{ width: '100%' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Invoice </TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Date</TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Payment</TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>TDS/TCS</TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total</TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Remark</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody >
                            {vendorPayment && vendorPayment.length > 0 && vendorPayment.map((_, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Button
                                            onClick={() => handlePrint(AllpurchaseData?.storeData?.[0]?.storeuploadFile)}
                                            disabled={index !== newPaymentIndex && isEditMode}
                                            sx={{
                                                color: index !== newPaymentIndex && isEditMode ? theme.palette.text.disabled : 'inherit',
                                            }}
                                        >
                                            <img
                                                src={`${Image_URL}/` + AllpurchaseData?.storeData?.[0]?.storeuploadFile}
                                                alt="avatar"
                                                width="50"
                                                height="50"
                                                style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                            /><RemoveRedEyeIcon sx={{ ml: 1 }} />
                                        </Button>

                                    </TableCell>
                                    <TableCell>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="date"
                                                label="Date :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.VendorPaymentDetails?.[index]?.VendorPaymentDate}
                                                name={`VendorPaymentDetails.${index}.VendorPaymentDate`}
                                                error={!!touched.VendorPaymentDetails?.[index]?.VendorPaymentDate && !!errors.VendorPaymentDetails?.[index]?.VendorPaymentDate}
                                                helperText={touched.VendorPaymentDetails?.[index]?.VendorPaymentDate && errors.VendorPaymentDetails?.[index]?.VendorPaymentDate}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={index !== newPaymentIndex && isEditMode}

                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Payment Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.VendorPaymentDetails?.[index]?.VendorPaymentAmount}
                                                name={`VendorPaymentDetails[${index}].VendorPaymentAmount`}
                                                error={!!touched.VendorPaymentDetails?.[index]?.VendorPaymentAmount && !!errors.VendorPaymentDetails?.[index]?.VendorPaymentAmount}
                                                helperText={touched.VendorPaymentDetails?.[index]?.VendorPaymentAmount && errors.VendorPaymentDetails?.[index]?.VendorPaymentAmount}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={index !== newPaymentIndex && isEditMode}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Payment TDS :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.VendorPaymentDetails?.[index]?.VendorPaymentTDS}
                                                name={`VendorPaymentDetails[${index}].VendorPaymentTDS`}
                                                error={!!touched.VendorPaymentDetails?.[index]?.VendorPaymentTDS && !!errors.VendorPaymentDetails?.[index]?.VendorPaymentTDS}
                                                helperText={touched.VendorPaymentDetails?.[index]?.VendorPaymentTDS && errors.VendorPaymentDetails?.[index]?.VendorPaymentTDS}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={index !== newPaymentIndex && isEditMode}
                                            />
                                        </FormControl>
                                    </TableCell>

                                    <TableCell>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Payment Total :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={Number(values.VendorPaymentDetails?.[index]?.VendorPaymentAmount || 0) + Number(values.VendorPaymentDetails?.[index]?.VendorPaymentTDS || 0)}
                                                name={`VendorPaymentDetails[${index}].VendorPaymentTotal`}
                                                error={!!touched.VendorPaymentDetails?.[index]?.VendorPaymentTotal && !!errors.VendorPaymentDetails?.[index]?.VendorPaymentTotal}
                                                helperText={touched.VendorPaymentDetails?.[index]?.VendorPaymentTotal && errors.VendorPaymentDetails?.[index]?.VendorPaymentTotal}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={index !== newPaymentIndex && isEditMode}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Remark :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.VendorPaymentDetails?.[index]?.VendorPaymentRemark}
                                                name={`VendorPaymentDetails[${index}].VendorPaymentRemark`}
                                                error={!!touched.VendorPaymentDetails?.[index]?.VendorPaymentRemark && !!errors.VendorPaymentDetails?.[index]?.VendorPaymentRemark}
                                                helperText={touched.VendorPaymentDetails?.[index]?.VendorPaymentRemark && errors.VendorPaymentDetails?.[index]?.VendorPaymentRemark}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={index !== newPaymentIndex && isEditMode}
                                            />
                                        </FormControl>
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableCell colSpan={6} sx={{ borderBottom: 'none' }}>
                                <Box display="flex" justifyContent="flex-end" m={1}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<AddIcon />}
                                        onClick={handleAddVendorPayment}
                                    >
                                        Add Vendor Payment
                                    </Button>
                                </Box>
                            </TableCell>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md">
                <DialogContent>
                    <img src={`${Image_URL}/` + AllpurchaseData?.storeData?.[0]?.storeuploadFile} alt="avatar" width="600" height="400" style={{ objectFit: 'cover', borderRadius: '5px' }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
                </DialogActions>
            </Dialog>


            <Box display="flex" mt={2}>
                <Box display="flex" justifyContent="space-between">
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            boxShadow: 5,
                            '&:hover': {
                                boxShadow: 6,
                            }
                        }}
                        onClick={() => navigate('/admin/vendor-payment')}
                    >
                        Back
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            boxShadow: 5,
                            '&:hover': {
                                boxShadow: 6,
                            },
                            marginLeft: '30px'
                        }}
                        onClick={handleSubmit}
                    >
                        {id ? 'Update' : 'Save'}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default AddVendorPayment;